import {
	ConstructionSiteList,
	GFAFullDetails,
	GFAReference,
} from "@dune/types";

export const isGFAConstructionSite = (
	constructionSite: ConstructionSiteList | GFAFullDetails,
): constructionSite is GFAFullDetails => {
	return "gfaFinancings" in constructionSite;
};

// Function to format number with leading zero if needed (for 'a' and 'ca' only)
export const formatWithLeadingZero = (value: number | string): string => {
	const num = Number(value);
	if (Number.isNaN(num) || num < 0 || num > 99) return "00";
	return num.toString().padStart(2, "0");
};

// Function to format ha values (always pad to 2 digits for consistency)
export const formatHaValue = (value: number | string): string => {
	const num = Number(value);
	if (Number.isNaN(num) || num < 0) return "00";
	return num < 10 ? num.toString().padStart(2, "0") : num.toString();
};
// Function to calculate total area in ca (centiares)
export const calculateTotalInCa = (references: GFAReference[]): number => {
	if (!references || references.length === 0) return 0;

	return references.reduce((total: number, reference: GFAReference) => {
		const ha = Number(reference.ha) || 0;
		const a = Number(reference.a) || 0;
		const ca = Number(reference.ca) || 0;

		// Convert everything to ca: 1 Ha = 10000 ca, 1 a = 100 ca
		const totalCa = ha * 10000 + a * 100 + ca;
		return total + totalCa;
	}, 0);
};

// Function to convert ca back to Ha/a/ca format
export const convertCaToHaAca = (
	totalCa: number,
): { ha: number; a: number; ca: number } => {
	const ha = Math.floor(totalCa / 10000);
	const remainingAfterHa = totalCa % 10000;
	const a = Math.floor(remainingAfterHa / 100);
	const ca = remainingAfterHa % 100;

	return { ha, a, ca };
};

// Function to validate input for 'a' and 'ca' (0-99)
export const validateSubUnitInput = (value: string): boolean => {
	const num = Number(value);
	return !Number.isNaN(num) && num >= 0 && num <= 99;
};

// Function to validate input for 'ha' (any positive number)
export const validateHaInput = (value: string): boolean => {
	const num = Number(value);
	return !Number.isNaN(num) && num >= 0;
};
